// Setup
import React from 'react'
import { defineMessages } from 'react-intl'
import PropTypes from 'prop-types'
import TableCell from '@material-ui/core/TableCell'
import TableRow from '@material-ui/core/TableRow'

// WeSpire
import Avatar, { AvatarSizes } from 'components/application/avatar'
import { intl } from 'utilities/localization'
import Link from 'components/shared/link'
import { parseDate } from 'utilities/date_utils'
import Stack from 'components/ui/stack'

const { formatMessage, formatDate } = intl

const messages = defineMessages({
  editFunds: {
    defaultMessage: 'Edit Funds',
    id: 'UserRow.editFunds',
  },
})

export const UserRow = ({
  id,
  name,
  avatarUrl,
  email,
  editProfilePath,
  givingaUser,
  ...props
}) => {
  return (
    <TableRow
      data-test="user-row"
      hover
      key={id}
      tabIndex={-1}
      {...props}
    >
      <TableCell component="th" scope="row">
        <Stack className="d-flex align-items-center justify-content-start">
          <Link to={editProfilePath}>
            <Avatar
              className="mr-2"
              image={avatarUrl}
              size={AvatarSizes.small}
            />
          </Link>
          <Stack className="d-flex flex-column" space={0}>
            <Link className="fw-semi-bold text-blue fs-2" to={editProfilePath}>
              {name}
            </Link>
            <Link className="fs-1 text-black-3" to={`mailto:${email}`}>
              {email}
            </Link>
          </Stack>
        </Stack>
      </TableCell>
      <TableCell align="right">
        {givingaUser?.employeeAccountNumber}
      </TableCell>
      <TableCell align="right">
        {givingaUser?.employeeAccountBalance}
      </TableCell>
      <TableCell align="right">
        <Link to={editProfilePath}>
          {formatMessage(messages.editFunds)}
        </Link>
      </TableCell>
    </TableRow>
  )
}

UserRow.propTypes = {
  avatarUrl: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  editProfilePath: PropTypes.string.isRequired,
  givingaUser: PropTypes.shape({
    employeeAccountNumber: PropTypes.number,
    employeeAccountBalance: PropTypes.number,
  }).isRequired,
}
